// extracted by mini-css-extract-plugin
module.exports = {"server-html":"Text_server-html__yBUxg"};